export const TextCapitalize = (text = '') => {
    if (!text) return '';

    return `${text?.charAt(0).toUpperCase()}${text?.slice(1)}`;
};

export const HyphenToCamelCase = (text = '') => {
    if (!text) return '';

    return text?.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
};

export const CamelCaseToHyphen = (text = '') => {
    if (!text) return '';

    return text?.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};
export default null;
